import Text from 'components/Text/Text';
import React, { useContext, useEffect, useRef } from 'react';
import { Select } from 'antd';
import { IGetModifierGroupsShort, IGetModifierGroupsShortResponse } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getModifierGroupsShortInfo } from 'backend/modifierGroups';
import SelectDropdownReloader from 'components/SelectDropdownReloader/SelectDropdownReloader';
import { useTranslation } from 'react-i18next';
import { IModifiersContext, ModifiersContext } from '../../../modifiersState/modifiersContext';
import style from './ModifierGroupSelect.module.scss';

const { Option } = Select;

const ModifierGroupSelect: React.FC = () => {
	const { setIDModifierGroup, IDSelectedRestaurant, IDSelectedModifierGroup } =
		useContext<IModifiersContext>(ModifiersContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { response, loading, refetch, responseError } = useFetchData<
		IGetModifierGroupsShortResponse,
		IGetModifierGroupsShort
	>(IDSelectedRestaurant ? getModifierGroupsShortInfo : null, { restaurantIds: [IDSelectedRestaurant || ''] });
	const { t } = useTranslation('listing');

	useEffect(() => {
		refetch();
	}, [IDSelectedRestaurant]);

	const handleSelect = (value: string) => {
		setIDModifierGroup(value);
	};

	const value = IDSelectedRestaurant && !loading ? IDSelectedModifierGroup : undefined;

	return (
		<div className={style.container} data-test="ModifierGroupSelect">
			<Text translationNameSpace="listing" translationKey="modifierGroupLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={handleSelect}
				value={value}
				showArrow={true}
				allowClear={true}
				disabled={!IDSelectedRestaurant}
				notFoundContent={responseError ? <SelectDropdownReloader onReload={refetch} /> : undefined}
				showSearch={true}
				filterOption={(inputValue, option) =>
					option?.children ? String(option.children).toLowerCase().includes(inputValue.toLowerCase()) : false
				}
				loading={loading}
				listItemHeight={response?.data.modifierGroups.length}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				placeholder={t('selectPlaceholder')}>
				{response?.data.modifierGroups.length ? (
					<>
						<Option className={style.disabledItem} value="empty" disabled={true}>
							<Text
								translationNameSpace="listing"
								translationKey="selectAnyItemPlaceholder"
								asFragment={true}
							/>
						</Option>
						{response.data.modifierGroups.map((el) => {
							return (
								<Option className={style.listItem} value={el.id} key={el.id}>
									{el.name}
								</Option>
							);
						})}
					</>
				) : null}
			</Select>
		</div>
	);
};

export default ModifierGroupSelect;
